export const BEYOND_WORDS_SCRIPT =
  "https://proxy.beyondwords.io/npm/@beyondwords/player@latest/dist/umd.js";
export const TOOLTIP_STORAGE_KEY = "hasSeenTTSTooltip";
export const CRAWL_START_DATE = "Jul 17, 2025";
